"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterHeader = exports.FilterColumn = exports.FilterIcon = exports.HeaderLabel = exports.HeaderCell = exports.HeaderRow = exports.ColumnNamesWrapper = exports.StyledSearchBar = exports.TableHeader = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DataGrid = require("../DataGrid.styles");

var _Icon = _interopRequireDefault(require("../../../IconicDisplayElements/Icon"));

var _SearchBar = _interopRequireDefault(require("../../../Inputs/SearchBar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// todo: continue removing the class names in preference of styled components
var TableHeader = _styledComponents.default.div.withConfig({
  displayName: "Headerstyles__TableHeader",
  componentId: "hnyxj-0"
})(["border-bottom:", ";.drop-down-wrapper{position:relative;}.drop-down{position:absolute;right:0;margin-top:0.3rem;background-color:", ";min-width:10rem;min-height:10rem;box-shadow:", ";border-radius:", ";padding-bottom:1rem;z-index:", ";}.reset-button{padding:0 1.625rem;font-weight:", ";color:", ";outline:none;cursor:pointer;}.search-bar-container{background-color:", ";border-radius:5rem;width:fit-content;padding:0 ", ";}.search-bar{width:20rem;outline:none;padding:0.25rem;}.search-icon{font-size:1rem;min-height:unset;min-width:unset;}.search-header{}.sort-arrow{margin-left:0.5rem;}"], _DataGrid.tableBorder, function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return props.theme.s_dropdown;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.modal;
}, function (props) {
  return props.theme.primaryMedium;
}, function (props) {
  return props.theme.c_foreground_primary;
}, function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return props.theme.standardPadding;
});

exports.TableHeader = TableHeader;
var StyledSearchBar = (0, _styledComponents.default)(_SearchBar.default).withConfig({
  displayName: "Headerstyles__StyledSearchBar",
  componentId: "hnyxj-1"
})(["padding-top:", ";"], function (props) {
  return props.theme.standardPadding;
});
exports.StyledSearchBar = StyledSearchBar;

var ColumnNamesWrapper = _styledComponents.default.div.withConfig({
  displayName: "Headerstyles__ColumnNamesWrapper",
  componentId: "hnyxj-2"
})(["display:none;margin:.5rem 0 .2rem 0;@media only screen and (min-width:", "){display:block;}"], function (props) {
  return props.theme.smallBreak;
});

exports.ColumnNamesWrapper = ColumnNamesWrapper;
var HeaderRow = (0, _styledComponents.default)(_DataGrid.Row).withConfig({
  displayName: "Headerstyles__HeaderRow",
  componentId: "hnyxj-3"
})(["align-items:center;justify-content:space-between;min-height:", ";"], function (props) {
  return props.theme.standardButtonHeight;
});
exports.HeaderRow = HeaderRow;
var HeaderCell = (0, _styledComponents.default)(_DataGrid.Cell).withConfig({
  displayName: "Headerstyles__HeaderCell",
  componentId: "hnyxj-4"
})(["position:relative;"]);
exports.HeaderCell = HeaderCell;

var HeaderLabel = _styledComponents.default.span.withConfig({
  displayName: "Headerstyles__HeaderLabel",
  componentId: "hnyxj-5"
})(["display:inline-block;font-weight:", ";"], function (props) {
  return props.theme.primaryHeavy;
});

exports.HeaderLabel = HeaderLabel;
var FilterIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "Headerstyles__FilterIcon",
  componentId: "hnyxj-6"
})(["margin-left:.25rem;"]);
exports.FilterIcon = FilterIcon;

var FilterColumn = _styledComponents.default.div.withConfig({
  displayName: "Headerstyles__FilterColumn",
  componentId: "hnyxj-7"
})(["flex:1;padding:0.5rem;min-width:10rem;"]);

exports.FilterColumn = FilterColumn;

var FilterHeader = _styledComponents.default.span.withConfig({
  displayName: "Headerstyles__FilterHeader",
  componentId: "hnyxj-8"
})(["font-weight:", ";"], function (props) {
  return props.theme.primaryMedium;
});

exports.FilterHeader = FilterHeader;